<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">Home</el-breadcrumb-item>
            <el-breadcrumb-item>Task Management</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 切换框，选择要展示的状态 -->
        <el-radio-group v-model="selectedStatus">
            <el-radio label="waiting">Waiting</el-radio>
            <el-radio label="started">Running</el-radio>
            <el-radio label="failed">Fail</el-radio>
            <el-radio label="destroyed">Destroyed</el-radio>
            <el-radio label="completed">Completed</el-radio>
        </el-radio-group>



        <!-- 仅显示特定状态卡片 -->
        <div v-for="statusGroup in filteredTaskList" :key="statusGroup.status">
            <el-card>
                <el-table :data="statusGroup.tasks">
                    <el-table-column type="index"></el-table-column>
                    <el-table-column prop="UserID" label="User" v-if="isAdmin"></el-table-column>
                    <el-table-column prop="DatasetName" label="Dataset"></el-table-column>
                    <el-table-column prop="MethodName" label="Method"></el-table-column>

                    <el-table-column label="Progress">
                        <template #default="{ row }">
                            <div>
                                <!-- Progress Bar -->
                                <el-progress :percentage="row.progress" />

                                <!-- Estimated Time -->
                                <div v-if="row.progress < 100">
                                    <span>{{ row.remainingTime }}</span>
                                </div>
                                <div v-else>
                                    <span>Completed</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="status" label="Status"></el-table-column>

                    <el-table-column fixed="right" label="Operation">
                        <template slot-scope="scope">

                            <div v-if="scope.row.status === 'started' || scope.row.status === 'waiting'" >
                            <!-- 摧毁进程 -->
                            <el-tooltip effect="dark" content="destroy" placement="top-start" :enterable="false">
                                <el-button type="warning" icon="el-icon-cpu" size="mini"
                                    @click="destroy_task(scope.row.id)"></el-button>
                            </el-tooltip>
                        </div>

                        <div v-else>
                            <el-tooltip v-if="isAdmin" effect="dark" content="destroy" placement="top-start">
                                <el-button
                                    type="danger"
                                    icon="el-icon-delete"
                                    size="mini"
                                    @click="delete_task(scope.row.id)">
                                </el-button>
                            </el-tooltip>
                        </div>
                        </template>
                    </el-table-column>

                </el-table>
            </el-card>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            isAdmin: false,
            Authorization: '',  // 登录token
            TaskList: [],       // 任务列表
            intervalId: null,  // 用于存储setInterval的ID

            selectedStatus: 'started', // 当前选择的状态


        };
    },


    created() {

        var user = JSON.parse(sessionStorage.getItem("user"));
        if (user) {
            this.Authorization = "Bearer " + user.access_token;

            // ⭐ 判断管理员（关键）
            this.isAdmin = Number(user.Level) > 0;
        }
        console.log(this.Authorization);


    },

    async mounted() {
        // 在组件加载时启动定时任务
        await this.getTaskList();  // 首次加载时立即获取数据

        // 启动定时任务
        this.intervalId = setInterval(async () => {
            await this.getTaskList();  // 每隔5秒刷新一次任务列表
        }, 3000);  // 3000毫秒 = 3秒
    },
    destroyed() {
        // 在组件销毁时清除定时器
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    },



    computed: {
        // 根据状态过滤任务列表
        filteredTaskList() {

            return this.groupedTaskList.filter(group => group.status === this.selectedStatus);
        },
        // 将任务按状态分组
        groupedTaskList() {


            const groups = {
                "waiting": [],
                "started": [],
                "failed": [],
                "completed": [],
                "destroyed": [],
            };

            // 根据任务的状态分类
            this.TaskList.forEach(task => {
                if (groups[task.status]) {
                    groups[task.status].push(task);
                }
            });

            // 返回分组后的列表
            return Object.keys(groups).map(status => ({
                status,
                tasks: groups[status],
            }));
        }
    },



    methods: {

        // 获取task状态列表
        async getTaskList() {
            try {
                const response = await this.$http.get("/get_tasks", {
                    headers: {
                        "Authorization": this.Authorization,
                    },
                });
                console.log(response);
                const taskData = response.data;
                // 使用 map 获取所有的异步任务，但返回的是 Promise 数组
                const taskPromises = Object.keys(taskData).map(async task_id => {
                    const task = taskData[task_id]; // 获取每个 task 的数据
                    const remainingTime = await this.getRemainingTime(task.Time, task.progress);

                    return {
                        id: task_id,                 // 添加 id 字段
                        status: task.status,
                        progress: task.progress,
                        MetricNames: task.MetricNames,
                        DatasetName: task.DatasetName,
                        information: task.information,
                        MethodName: task.MethodName,
                        Time: task.Time,
                        remainingTime: remainingTime
                    };
                });

                // 使用 Promise.all 等待所有任务完成
                this.TaskList = await Promise.all(taskPromises);
                console.log(this.TaskList);
            } catch (error) {
                console.error(error);
                this.$message.error(error.response.data.msg || 'Failed to fetch task list');
            }
        },

        async updateRemainingTime(task) {
            await this.getRemainingTime(task);
        },
        async getRemainingTime(time, progress) {
            if (progress < 100) {

                const local_time = Date.now(); // 毫秒

                // ⭐ 直接用 timestamp（秒 → 毫秒）
                const task_time = time * 1000;

                const time_difference = local_time - task_time;

                if (time_difference <= 0) return "Calculating...";

                const per_second_progress = progress / (time_difference / 1000);

                if (per_second_progress <= 0) return "Calculating...";

                const remaining_second = (100 - progress) / per_second_progress;

                return `Remaining: ${this.formatTime(remaining_second)}`;

            } else {
                return 'Completed';
            }
        },



         // 删除进程
         async delete_task(task_id) {
          
            const confirmResult = await this.$confirm('This action will permanently delete the task record. Continue?', 'Warning', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning',
            }).catch(() => false);

            if (!confirmResult) {
                this.$message.info("Deletion cancelled");
            }

            try {
                const response = await this.$http.post("/delete_task", {"TaskID":task_id}, {
                    headers: {
                        "Authorization": this.Authorization,
                        "Content-Type": "application/json",
                    },
                });
                this.$message.success(response.data.msg);
                this.getTaskList();;
            } catch (error) {
                console.error(error);
                                this.$message.error(
                    error.response?.data?.error ||
                    error.response?.data?.msg ||
                    'Fail to delete'
                );
            }

        },


          // 摧毁进程
          async destroy_task(task_id) {
          
          const confirmResult = await this.$confirm('This action will permanently terminate the task. Continue?', 'Warning', {
              confirmButtonText: 'Confirm',
              cancelButtonText: 'Cancel',
              type: 'warning',
          }).catch(() => false);

          if (!confirmResult) {
              this.$message.info("Termination cancelled");
          }

          try {
              const response = await this.$http.post("/destroy_task", {"TaskID":task_id}, {
                  headers: {
                      "Authorization": this.Authorization,
                      "Content-Type": "application/json",
                  },
              });
              this.$message.success(response.data.msg);
              this.getTaskList();;
          } catch (error) {
              console.error(error);
              // this.$message.error(error.response.data.msg || '删除方法失败');
          }

      },







        // Method to format time in seconds to a readable format (hh:mm:ss)
        formatTime(seconds) {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const remainingSeconds = Math.floor(seconds % 60);
            return `${hours}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
        }

    }
};

</script>

<style scoped>
/* 可以根据需要自定义样式 */
</style>